// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"19000d6c","151":"0cde1939","222":"2ab38aa2","496":"c11637ec","560":"771b2055","626":"e2800f3d","849":"6712222a","867":"2aa3f2c2","928":"699e8c3e","958":"803c3dc0","976":"fb3ec225"}[chunkId] + ".chunk.js";
};